import type { DeepPartial } from '@luna/utils-ts';
import { BUNDLE_ORDER_TYPE } from '@shared/payments-types';

import type { PaymentOrders } from './PaymentOrders';

export const HR: DeepPartial<PaymentOrders> = {
    showId: true,
    alwaysRedo: false,
    orderBundler: {
        config: {
            DEFAULT: [
                {
                    combination: [BUNDLE_ORDER_TYPE.OWN_FX],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC],
                    maxSize: 200,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.SEPA, BUNDLE_ORDER_TYPE.INTERNATIONAL],
                    maxSize: 200,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
        },
    },
    failedOrderStates: [
        'KAG',
        'RDE',
        'SNM',
        'NGD',
        'NGA',
        'ADB',
        'NBA',
        'CBA',
        'CSA',
        'LGR',
        'BBC',
        'AGB',
        'OBG',
        'UNG',
        'BNZ',
        'ENE',
        'BLA',
        'FUS',
        'ABG',
        'UNK',
        'DDB',
        'DDD',
        'DDL',
        'DDC',
        'CBB',
        'ABG',
        'RED',
        'XPR',
        'BAM',
        'BAN',
        'BPA',
        'BPR',
        'EEI',
        'FRD',
        'IPA',
        'IPC',
        'IPE',
        'ISA',
        'RBC',
        'REC',
    ],
    requestDoubleSigningInCaseOfPossibleFraud: true,
    shouldShowFraudAndScamPatternsLink: false,
};
